import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, Paper, CircularProgress, Typography, Alert } from '@mui/material';

// /autologin?id=<user_id> — passwordless entry point launched by a trusted
// caller (e.g. the desktop app opening the dashboard for its already
// signed-in user). The actual security check (User-Agent must contain
// "zyco") happens server-side; this page just drives the request and
// hands the user into the same session state a normal login would.
export default function AutoLogin() {
    const [params] = useSearchParams();
    const navigate  = useNavigate();
    const { autologin } = useAuth();
    const [error, setError] = React.useState('');

    React.useEffect(() => {
        const id = params.get('id');
        if (!id) {
            setError('Missing user id.');
            return;
        }
        let cancelled = false;
        autologin(id)
            .then(() => { if (!cancelled) navigate('/', { replace: true }); })
            .catch((err) => { if (!cancelled) setError(err.message || 'Auto login failed.'); });
        return () => { cancelled = true; };
    }, [params, autologin, navigate]);

    return (
        <Box sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 2,
        }}>
            <Paper elevation={3} sx={{ width: '100%', maxWidth: 420, p: 5, borderRadius: 4, textAlign: 'center' }}>
                {error ? (
                    <Alert severity="error" variant="outlined" sx={{ borderRadius: 2.5 }}>{error}</Alert>
                ) : (
                    <>
                        <CircularProgress sx={{ mb: 2 }} />
                        <Typography color="text.secondary">Signing you in…</Typography>
                    </>
                )}
            </Paper>
        </Box>
    );
}
